import { Parametrized } from '@flippingbook/web.utils/dist/service';
import { createSearchParams } from 'react-router-dom';

import type { SamlApi } from './apis/saml-api';
import type { IOptionsService } from './options';

export class Saml extends Parametrized<Saml.Params> {
    async verifySamlIdp(params: Saml.SamlIdpParams) {
        const { idp } = params;

        try {
            const response = await this.params.samlApi.verifySamlIdp({
                IdpName: idp,
            });

            return response.Success;
        } catch {
            return false;
        }
    }

    navigateToSamlProvider(params: Saml.SamlIdpParams) {
        const { idp } = params;

        const design = this.params.optionsService.getDesign();
        const searchArgs: Record<string, string> = {
            ...this.params.optionsService.getQueryArgs(),
            r: this.params.optionsService.getAppId(),
            ...(design && { d: design }),
        };
        delete searchArgs.idp;
        delete searchArgs.email;
        const searchParams = createSearchParams(searchArgs).toString();

        this.params.samlApi.navigateToSamlProvider({
            IdpName: idp,
            Query: searchParams,
        });
    }
}

export namespace Saml {
    export interface SamlIdpParams {
        idp: string;
    }

    export interface Params {
        samlApi: SamlApi;
        optionsService: IOptionsService;
    }
}
